import { jsx, jsxs } from 'react/jsx-runtime';
import { useMutationExportResources } from '../mutations/useMutationExportResources.js';
import { useIsUnfinishedRequestByResourceId } from '../queries/useQueryExportRequests.js';
import { toast } from '../../store/alerts.js';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { Flex } from '@fabric-app/ui/components/Flex';
import { Spinner } from '@fabric-app/ui/components/Spinner';
import { IconExport } from '@fabric-app/icons/svg';

const DropdownItemExport = ({ resourceId, toastProps, label }) => {
  const mutationExport = useMutationExportResources();
  const hasUnfinishedExport = useIsUnfinishedRequestByResourceId(resourceId);
  const isExportRunning = hasUnfinishedExport || mutationExport.isPending;
  return /* @__PURE__ */ jsx(DropdownMenu.Item, {
    iconElement: /* @__PURE__ */ jsx(IconExport, {}),
    disabled: isExportRunning,
    onClick: () => {
      toast({
        id: "data-export",
        replace: true,
        ...toastProps
      });
      mutationExport.mutateAsync({
        resourceIds: [
          resourceId
        ]
      });
    },
    children: /* @__PURE__ */ jsxs(Flex, {
      flexGrow: 1,
      alignItems: "center",
      gap: 12,
      justifyContent: "space-between",
      children: [
        label,
        isExportRunning && /* @__PURE__ */ jsx(Spinner, {
          size: 12
        })
      ]
    })
  });
};

export { DropdownItemExport };
//# sourceMappingURL=DropdownItemExport.js.map
